<template>
  <div>
    <div class="d-flex">
      <h4>Configuração das Colunas do Arquivo</h4>
      <b-button
        @click="addColuna"
        size="sm"
        variant="info"
        class="ml-auto mb-3 rounded-pill"
      >
        <font-awesome-icon icon="plus-circle" />
        Adicionar coluna
      </b-button>
    </div>

    <b-table-simple hover small caption-top responsive class="table-config">
      <b-thead>
        <b-tr>
          <b-th v-for="n in num_columns" :key="'head-' + n">
            {{ (n - 1) | letra }}
            <font-awesome-icon
              icon="fa-solid fa-xmark"
              class="text-danger remove-column"
              @click="removeColumn(n - 1)"
            />
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr>
          <b-td v-for="n in num_columns" :key="'col-' + n">
            <b-select v-model="config[n - 1]" :options="options" size="sm" />
          </b-td>

          <b-td />
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    config: [],
    options: [
      { value: "oportunidades.id", text: "ID" },
      { value: "oportunidades.codigo", text: "Código" },
      { value: "oportunidades.nome", text: "Oportunidade" },
      { value: "origem", text: "Origem" },
      { value: "concedentes.nome", text: "Concedente" },
      { value: "categorias", text: "Categorias" },
      {
        value: "oportunidades.qualificacao_propostas",
        text: "Qualificação Proposta",
      },
      { value: "areas", text: "Áreas" },
      { value: "estados", text: "Estados" },
      { value: "municipios", text: "Municípios" },
      { value: "moedas.nome", text: "Moeda" },
      { value: "oportunidades.valor_total", text: "Valor Total" },
      { value: "oportunidades.valor_projeto", text: "Valor Projeto" },
      { value: "naturezas", text: "Atende a" },
      {
        value: "oportunidades.data_disponibilizacao",
        text: "Data Disponibilização",
      },
      {
        value: "oportunidades.data_proposta_ini",
        text: "Data Inicio Propostas",
      },
      { value: "oportunidades.data_proposta_fim", text: "Data Fim Propostas" },
      { value: "oportunidades.created_at", text: "Data Criação" },
      { value: "oportunidades.updated_at", text: "Data Atualização" },
    ],
  }),
  computed: {
    ...mapState("relatorios", ["relatorio_oportunidades"]),
    num_columns() {
      return this.config.length;
    },
  },
  watch: {
    config() {
      this.$emit("input", this.config);
    },
  },
  methods: {
    addColuna() {
      this.config.push("");
    },
    removeColumn(n) {
      this.config.splice(n, 1);
    },
  },
  mounted() {
    this.config = [
      "oportunidades.id",
      "oportunidades.codigo",
      "oportunidades.nome",
      "origem",
      "concedentes.nome",
      "categorias",
      "oportunidades.qualificacao_propostas",
      "areas",
      "estados",
      "municipios",
      "moedas.nome",
      "oportunidades.valor_total",
      "oportunidades.valor_projeto",
      "naturezas",
      "oportunidades.data_disponibilizacao",
      "oportunidades.data_proposta_ini",
      "oportunidades.data_proposta_fim",
      "oportunidades.created_at",
      "oportunidades.updated_at",
    ];
  },
};
</script>

<style lang="scss">
.table-config {
  padding-bottom: 1rem;
  th {
    text-align: center;
    background: #e7e7e7;
    color: #616262;
    font-size: 0.8rem !important;
    text-transform: uppercase;
    color: #666;
    border: none !important;
    padding: 0.2rem !important;

    width: 130px;
    min-width: 130px;
    max-width: 130px;

    &:hover {
      .remove-column {
        position: absolute;
        opacity: 1;
      }
    }
    .remove-column {
      position: absolute;
      right: 5px;
      opacity: 0;
      transition: all 0.3s;
    }
  }

  td {
    padding: 0px !important;

    select {
      padding: 0px;
    }
  }
}
</style>
